import { createSelector } from "reselect";
import translateObject from "../../utilities/translateObject";
import {
  HWK_SPORT_TYPE,
  HWK_SPORT_VARIANT
} from "../../../types/Conditionable";
import getRegion from "./getRegion";

const getParameters = state => state.advisor;
const getConditions = state => state.conditions.data;

const closestUp = (arr, closestTo) => {
  let closest = Math.max.apply(null, arr);

  for (let i = 0; i < arr.length; i++) {
    if (arr[i] >= closestTo && arr[i] < closest) closest = arr[i];
  }

  return closest;
};

const getClosestConditions = (parameters, conditions) => {
  console.log("Getting closest conditions for:", parameters, conditions);

  const maxTemperatures = [];

  conditions.forEach(condition => {
    maxTemperatures.push(condition.temperature_max);
  });

  const closestMaxTemp = closestUp(maxTemperatures, parameters.temperature);

  console.log("MAX TEMPS", maxTemperatures);
  console.log("CLOSEST", closestMaxTemp);

  return conditions.filter(condition => condition.temperature_max === closestMaxTemp);
};

const selectConditions = createSelector(
  [getRegion, getParameters, getConditions],
  (region, advisor, conditions) => {
    const filteredConditions = conditions
      .filter(condition => {
        const conditionableType = advisor.sportVariant
          ? HWK_SPORT_VARIANT
          : HWK_SPORT_TYPE;
        const conditionableId = advisor.sportVariant
          ? advisor.sportVariant
          : advisor.sportType;

        return (
          condition.conditionable_type === conditionableType &&
          condition.conditionable_id === conditionableId
        );
      })
      .filter(condition => {
        return (
          condition.humidity_min <= advisor.parameters.humidity &&
          condition.humidity_max >= advisor.parameters.humidity
        );
      })
      .filter(condition => {
        return (
          condition.temperature_min <= advisor.parameters.temperature &&
          condition.temperature_max >= advisor.parameters.temperature
        );
      })
      .filter(condition => condition.snow_type === advisor.parameters.snowType)
      .map(condition => {
        return Object.assign({}, condition, {
          protip: translateObject(condition.protip, region.language, false),
        });
      });;

    return getClosestConditions(advisor.parameters, filteredConditions);
  }
);

export default selectConditions;
